<template>
  <div class="pt-5 mb-6">
    <v-btn v-show="cancelLabel" color="gray" class="mr-2" text @click="$emit('cancel-click')" :disabled="disabled" :loading="loading">
      <v-icon small class="mr-2"> mdi-arrow-left </v-icon>{{ cancelLabel }}
    </v-btn>
    <v-btn color="primary" class="mx-2" :disabled="disabled || !canValidate" @click="$emit('valid-click')" :loading="loading">
      {{ validLabel }}
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    cancelLabel: {
      type: String,
      default: null
    },
    validLabel: {
      type: String,
      default: null
    },
    canValidate: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
</style>